import {createContext} from '@chakra-ui/react-context';
import type {AlertProps, SystemStyleObject} from '@chakra-ui/react';
import {createStylesContext} from '@chakra-ui/react';

import type {Part} from './theme/anatomy';

const ComponentName = `Alert` as const;

// NOTE: for now chakra does not export hook, so we need to do it manually
export const [AlertProvider, useAlertContext] = createContext<Pick<AlertProps, 'size' | 'status'>>({
  name: `AlertContext`,
  hookName: `useAlertContext`,
  providerName: `<Alert />`,
});

export const [StylesProvider, _useStyles] = createStylesContext(ComponentName);

export const useStyles = _useStyles as () => Record<Part, SystemStyleObject>;
